import * as customersList from './customers.service';
export const CustomersService = {
  ...customersList,
};
